import $ from 'jquery';
import validate from 'jquery-validation';

export const Globals = {
    $,
    validate,
};
